import { Component, Host, h, Prop } from '@stencil/core';
import { endpoints } from '../../../.conf/resources';
@Component({
  tag: 'cms-badge',
  styleUrl: 'cms-badge.scss',
  shadow: true,
})
export class CmsBadge {
  private badgeBgImage = 'badge-bg.webp';
  private imageSrc = `${endpoints.assetPath}/${this.badgeBgImage}`;

  /**
   * Displayed the Badge Name as Text
   */
  @Prop() name: string;

  render() {
    return (
      <Host>
        {this.name != undefined ? (
          <span
            style={{ backgroundImage: `url(${this.imageSrc})` }}
            class={'cms-badge-wrapper'}
          >
            <span class={'badge-name'}>{this.name}</span>
          </span>
        ) : null}
      </Host>
    );
  }
}
